import { Component, Input } from '@angular/core';
import * as moment from 'moment';

/**
 *
 * */
@Component({
  selector: 'campfire-event-card',
  templateUrl: './event-card.component.html',
  styleUrls: ['./event-card.component.scss']
})
export class EventCardComponent {
  @Input() event: any;

  get bodyPreviewLines(): string[] {
    return (<string>this.event.bodyPreview).split('\n');
  }

  get tz(): string {
    if (moment(this.utcDate).isDST()) {
      return 'EDT';
    }

    return 'EST';
  }

  get utcDate(): Date {
    return new Date(this.event.start.dateTime + 'Z');
  }
}

